import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { useHistory } from 'react-router-dom';
// import classNames from 'classnames';
import { useSearchParams } from 'react-router-dom';

import './AnalyticsDashboard.scss';
import AnimatedList from '../../molecules/AnimatedList/AnimatedList';
import AnalyticsNetworkNewsroomOverview from '../../molecules/AnalyticsNetworkNewsroomOverview/AnalyticsNetworkNewsroomOverview';
import AnalyticsNetworkBusinessOverview from '../../molecules/AnalyticsNetworkBusinessOverview/AnalyticsNetworkBusinessOverview';
import AnalyticsPlatformUsetmxOverview from '../../molecules/AnalyticsPlatformUsetmxOverview/AnalyticsPlatformUsetmxOverview';
import AnalyticsPlatformTmxSearchOverview from '../../molecules/AnalyticsPlatformTmxSearchOverview/AnalyticsPlatformTmxSearchOverview';

// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   ArcElement,
//   PointElement,
//   LineElement,
//   Filler
// } from 'chart.js';
// import { Bar, Doughnut, Chart, Line } from 'react-chartjs-2';
// import { Bar } from 'react-chartjs-2';
// import * as ChartGeo from 'chartjs-chart-geo';
import DropDown from '../../atoms/DropDown/DropDown';

import { InitialAnalyticsData } from '../../../Apis/actions/analytics-dashboard-actions';
// import * as moment from 'moment';

const AnalyticsDashboard = ({ subSection }) => {
  const dispatch = useDispatch();
  const { responseData, loading } = useSelector((state) => state.analyticsDashboardReducer);
  // const { loggedIn, userData } = useSelector((state) => state.signInReducer);

  // console.log('subSection', subSection);
  const [searchParams] = useSearchParams();

  const optionsData = ['This Day', 'This Week', 'This Month'];
  const [overallDataSetType, setOverallDataSetType] = useState('This Day');
  const [overallDataSetTypeConst, setOverallDataSetTypeConst] = useState('DAY');

  const userEmail =
    searchParams.get('email') || JSON.parse(localStorage.getItem('userData'))?.email;
  const userToken =
    searchParams.get('token') || JSON.parse(localStorage.getItem('userData'))?.token;

  const selectCallback = useCallback((data) => {
    setOverallDataSetType(data);
    if (data === 'This Day') {
      // dispatch(InitialAnalyticsData({ date_format: 'DAY' }, ''));
      setOverallDataSetTypeConst('DAY');
    } else if (data === 'This Week') {
      // dispatch(InitialAnalyticsData({ date_format: 'WEEK' }, ''));
      setOverallDataSetTypeConst('WEEK');
    } else if (data === 'This Month') {
      // dispatch(InitialAnalyticsData({ date_format: 'MONTH' }, ''));
      setOverallDataSetTypeConst('MONTH');
    }
  }, []);

  // const chartRef = useRef();
  // const [, setData] = useState([]);
  // const [, setChangeStyle] = useState(false);

  // useEffect(() => {
  //   dispatch(InitialAnalyticsData({ date_format: overallDataSetTypeConst }, ''));
  // }, [dispatch, overallDataSetTypeConst]);

  useEffect(() => {
    dispatch(
      InitialAnalyticsData(
        {
          // date_format: overallDataSetTypeConst,
          // type: 'NEWSROOM',
          email: userEmail,
          token: userToken
        },
        overallDataSetTypeConst
      )
    );
    const intervalId = setInterval(() => {
      dispatch(
        InitialAnalyticsData(
          {
            // date_format: overallDataSetTypeConst,
            // type: 'NEWSROOM',
            email: userEmail,
            token: userToken
          },
          overallDataSetTypeConst
        )
      );
    }, 5 * 60 * 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, [dispatch, overallDataSetTypeConst, userEmail, userToken]);

  // useEffect(() => {
  //   if (combinedMapData) {
  //     setData(
  //       ChartGeo.topojson.feature(
  //         combinedMapData,
  //         combinedMapData?.objects?.countries1
  //         //@ts-ignore
  //       ).features
  //     );
  //     setTimeout(() => {
  //       setChangeStyle(true);
  //     }, 2000);
  //     setTimeout(() => {
  //       setChangeStyle(false);
  //     }, 3000);
  //   }
  // }, [combinedMapData]);

  // ChartJS.register(
  //   CategoryScale,
  //   LinearScale,
  //   BarElement,
  //   Title,
  //   Tooltip,
  //   Legend,
  //   ArcElement,
  //   PointElement,
  //   LineElement,
  //   Filler,
  //   ChartGeo.ChoroplethController,
  //   ChartGeo.ProjectionScale,
  //   ChartGeo.ColorScale,
  //   ChartGeo.GeoFeature
  // );

  // const definition = {
  //   'Publishable Copy': {
  //     Uploads: 'Publishable copy uploaded onto the TMX platform.',
  //     Opens: "'Open' action of publishable copy.",
  //     'View more': "'View More' clicks of publishable copy.",
  //     'Copy Link': "'Copy Link' clicks of publishable copy.",
  //     Searches: 'Searches for publishable copy by using the search \n function. '
  //   },
  //   'Cleared Videos/Photos': {
  //     Uploads: 'Cleared videos/photos uploaded onto the TMX platform. ',
  //     Opens: "'Open' action of cleared videos/photos. ",
  //     'Agre..': "'Free to use' clicks of cleared videos/photos.",
  //     'Down..': "'Download' action of cleared videos/photos. ",
  //     'Embe..': "'Embed' action of cleared videos/photos.",
  //     Cleared: "'Clear Video' requests submitted on the TMX platform. ",
  //     'Sear..': 'Searches for cleared videos/photos by using the search \n function. '
  //   },
  //   'Story Contact': {
  //     '7d ago': "'Open' action of story contacts. ",
  //     Today: 'Searches for story contacts by using the search function. '
  //   },
  //   'Social Spotter': {
  //     '7d ago': "'Open' action of SocialSpotter Content. ",
  //     Today: 'Searches for SocialSpotter content by using the search function.'
  //   },
  //   'Story Contact Bar': {
  //     Uploads: 'Story contact uploads onto the TMX platform.',
  //     Opens: "'Open' action of story contacts. ",
  //     Searches: 'Searches for story contacts by using the search function.'
  //   },
  //   'Social Spotter Bar': {
  //     Uploads: 'SocialSpotter uploads onto the TMX platform.',
  //     Opens: "'Open' action of SocialSpotter Content. ",
  //     Searches: 'Searches on SocialSpotter using the search function.'
  //   },
  //   'Story Ideas': {
  //     Uploads: "'Need an Expert' uploads on the TMX platform.",
  //     Opens: "'Open' action of 'Need an Expert'.",
  //     Interested: "'Interested' action of 'Need an Expert'.",
  //     'Not Inter..': "'Not Interested' action of 'Need an Expert'.",
  //     Searches: "Searches for 'Need an Expert' using the search function."
  //   },
  //   Messages: {
  //     Experts: 'Message requests for experts on the TMX platform.',
  //     Videos: 'Message requests for clearing videos on the TMX platform.',
  //     Contacts: 'Message requests for contacts on the TMX platform.',
  //     General: 'General requests and questions on the TMX platform.'
  //   }
  // };

  // Chart.scaleService.updateScaleDefaults('category', {
  //   ticks: {
  //     callback: function (tick) {
  //       var characterLimit = 5;
  //       if (tick.length >= characterLimit) {
  //         return (
  //           tick
  //             .slice(0, tick.length)
  //             .substring(0, characterLimit - 1)
  //             .trim() + '...'
  //         );
  //       }
  //       return tick;
  //     }
  //   }
  // });

  // const convertToInternationalCurrencySystem = (labelValue) => {
  //   // Nine Zeroes for Billions
  //   return Math.abs(Number(labelValue)) >= 1.0e9
  //     ? (Math.abs(Number(labelValue)) / 1.0e9).toFixed(1) + 'B'
  //     : // Six Zeroes for Millions
  //     Math.abs(Number(labelValue)) >= 1.0e6
  //     ? (Math.abs(Number(labelValue)) / 1.0e6).toFixed(0)
  //     : // Three Zeroes for Thousands
  //     Math.abs(Number(labelValue)) >= 1.0e3
  //     ? (Math.abs(Number(labelValue)) / 1.0e3).toFixed(1) + 'K'
  //     : Math.abs(Number(labelValue));
  // };

  // const generateBarGraphMapOptions = (type) => {
  //   return {
  //     responsive: true,
  //     maintainAspectRatio: true,
  //     scales: {
  //       y: {
  //         // title: {
  //         //   display: true,
  //         //   text: 'Value'
  //         // },
  //         // min: 0,
  //         // max: 100,
  //         ticks: {
  //           // forces step size to be 50 units
  //           stepSize: 50
  //         }
  //       }
  //     },
  //     plugins: {
  //       tooltip: {
  //         intersect: type === 'Story Contact' || type === 'Social Spotter' ? true : false,
  //         mode: type === 'Story Contact' || type === 'Social Spotter' ? 'point' : 'index',
  //         callbacks: {
  //           title: function (tooltipItems) {
  //             if (type === 'Cleared Videos/Photos') {
  //               const title =
  //                 tooltipItems[0].label === 'Uploads'
  //                   ? 'Uploads'
  //                   : tooltipItems[0].label === 'Opens'
  //                   ? 'Opens'
  //                   : tooltipItems[0].label === 'Agre..'
  //                   ? 'Agreements'
  //                   : tooltipItems[0].label === 'Down..'
  //                   ? 'Downloads'
  //                   : tooltipItems[0].label === 'Embe..'
  //                   ? 'Embeds'
  //                   : tooltipItems[0].label === 'Cleared'
  //                   ? 'Cleared'
  //                   : tooltipItems[0].label === 'Sear..'
  //                   ? 'Searches'
  //                   : '';
  //               return title;
  //             } else if (type === 'Story Ideas') {
  //               const title =
  //                 tooltipItems[0].label === 'Not Inter..'
  //                   ? 'Not Interested'
  //                   : tooltipItems[0].label;
  //               return title;
  //             }
  //             if (type === 'Story Contact' || type === 'Social Spotter') {
  //               if (tooltipItems[0].datasetIndex === 0) {
  //                 return 'Opens';
  //               } else if (tooltipItems[0].datasetIndex === 1) {
  //                 return 'Searches';
  //               }
  //             } else {
  //               return tooltipItems[0].label;
  //             }
  //           },
  //           label: function (tooltipItems) {
  //             if (type === 'Story contact') {
  //               // return 'Definition: ' + definition[type][tooltipItems[0].label];
  //               return 'Total: ' + tooltipItems.raw;
  //             } else {
  //               return 'Total: ' + tooltipItems.raw;
  //             }
  //           },
  //           footer: function (tooltipItems) {
  //             if (type === 'Story Contact' || type === 'Social Spotter') {
  //               if (tooltipItems[0].datasetIndex === 0) {
  //                 return 'Definition: ' + definition[type]['7d ago'];
  //               } else if (tooltipItems[0].datasetIndex === 1) {
  //                 return 'Definition: ' + definition[type]['Today'];
  //               }
  //             } else {
  //               return 'Definition: ' + definition[type][tooltipItems[0].label];
  //             }
  //           }
  //         }
  //       },
  //       legend: {
  //         position: 'top',
  //         display: false
  //       },
  //       title: {
  //         display: false,
  //         text: 'Publishable Copy'
  //       }
  //     }
  //   };
  // };

  // const labels = [
  //   responseData?.cleared_article_views
  //     ? moment(responseData?.cleared_article_views[0]?.date, 'YYYYMM').format('MMMM, YYYY')
  //     : ''
  // ];

  // const data = {
  //   labels,
  //   datasets: [
  //     {
  //       label: 'Views',
  //       data: responseData?.cleared_article_views
  //         ? [responseData?.cleared_article_views[0]?.views]
  //         : '',
  //       backgroundColor: '#d1ceff'
  //     },
  //     {
  //       label: 'Copy links',
  //       data: responseData?.cleared_article_copy_links
  //         ? [responseData?.cleared_article_copy_links[0]?.count]
  //         : '',
  //       backgroundColor: '#ada8fe'
  //     }
  //   ]
  // };

  // const generateMapData = (rawDataArray) => {
  //   return {
  //     labels,
  //     datasets: rawDataArray.map((data) => ({
  //       label: data.label,
  //       data: responseData[data.type]
  //         ? data.mapAllData
  //           ? responseData[data.type].map((mapData) => mapData[data.typeValue])
  //           : [responseData[data.type][0][data.typeValue]]
  //         : '',
  //       // data: responseData[data.type]
  //       //   ? responseData[data.type].map((mapData) => mapData[data.typeValue])
  //       //   : '',
  //       backgroundColor: data?.backgroundColor
  //     }))
  //   };
  // };

  // const generateAreaMapData = (rawDataArray) => {
  //   return {
  //     labels: rawDataArray.map((data) => data.label),
  //     datasets: rawDataArray.map((data) => ({
  //       label: data.label,
  //       data: responseData[data.type]
  //         ? data.mapAllData
  //           ? responseData[data.type].map((mapData) => mapData[data.typeValue])
  //           : [
  //               responseData[data.type][1][data.typeValue],
  //               responseData[data.type][0][data.typeValue]
  //             ]
  //         : '',
  //       fill: data?.fill,
  //       backgroundColor: data?.backgroundColor,
  //       borderColor: data?.borderColor
  //     }))
  //   };
  // };

  // const generateMapDataTest = (rawDataArray) => {
  //   return {
  //     labels: rawDataArray.map((data) => data.label),
  //     productNames: rawDataArray.map((data) => data.label),
  //     datasets: [
  //       {
  //         label: 'Value',
  //         data: rawDataArray.map((data) =>
  //           responseData[data.type]
  //             ? data.mapAllData
  //               ? responseData[data.type].map((mapData) => mapData[data.typeValue])
  //               : responseData[data.type][0][data.typeValue]
  //             : ''
  //         ),
  //         // data: responseData[data.type]
  //         //   ? responseData[data.type].map((mapData) => mapData[data.typeValue])
  //         //   : '',
  //         backgroundColor: rawDataArray.map((data) => data.backgroundColor)
  //       }
  //     ]
  //   };
  // };

  //   'generateAreaMapData',
  //   generateAreaMapData([
  //     {
  //       type: 'story_contact_opens',
  //       backgroundColor: 'rgba(156,236,175)',
  //       borderColor: 'rgba(156,236,175)',
  //       typeValue: 'views',
  //       label: '7d ago',
  //       fill: '-1'
  //     },
  //     {
  //       type: 'story_contact_searches',
  //       backgroundColor: 'rgba(139,132,254)',
  //       borderColor: 'rgba(139,132,254)',
  //       typeValue: 'searches',
  //       label: 'Today',
  //       fill: '1'
  //     }
  //   ])
  // );

  //   'generateMapData',
  //   generateMapData([
  //     {
  //       type: 'cleared_article_views',
  //       backgroundColor: '#d1ceff',
  //       typeValue: 'views',
  //       label: ''
  //     },
  //     {
  //       type: 'cleared_article_copy_links',
  //       backgroundColor: '#ada8fe',
  //       typeValue: 'count',
  //       label: ''
  //     },
  //     {
  //       type: 'cleared_article_view_more',
  //       backgroundColor: '#8b84fe',
  //       typeValue: 'count',
  //       label: ''
  //     }
  //   ])
  // );

  // const generateMapOptions = (options) => {
  //   return {
  //     responsive: !options.responsive ? options.responsive : true,
  //     maintainAspectRatio: !options.maintainAspectRatio ? options.maintainAspectRatio : true,
  //     plugins: {
  //       legend: {
  //         position: 'top',
  //         display: !options.legend ? options.legend : true
  //       },
  //       title: {
  //         display: false,
  //         text: 'Publishable Copy'
  //       }
  //     }
  //   };
  // };

  // const pieData = {
  //   labels: responseData?.countries ? responseData?.countries.map((data) => data.country) : [],
  //   datasets: [
  //     {
  //       label: '# of Votes',
  //       data: responseData?.countries ? responseData?.countries.map((data) => data.count) : [],
  //       backgroundColor: ['#d1ceff', ' #ada8fe', '#8b84fe'],
  //       borderColor: [
  //         'rgba(255, 99, 132, 1)',
  //         'rgba(54, 162, 235, 1)',
  //         'rgba(255, 206, 86, 1)',
  //         'rgba(75, 192, 192, 1)',
  //         'rgba(153, 102, 255, 1)',
  //         'rgba(255, 159, 64, 1)'
  //       ],
  //       borderWidth: 1
  //     }
  //   ]
  // };

  return (
    <>
      <section className="tmx-analyticsDashboard">
        {/* <Bar options={options} data={data} /> */}
        <div className="tmx-analyticsDashboard__topTextContainer">
          <div className="tmx-analyticsDashboard__topTextContainerLeft">
            <h1 className="tmx-analyticsDashboard__topTextTitle">
              {subSection === 'newsrooms'
                ? 'Newsroom User KPIs'
                : subSection === 'business'
                ? 'Business User KPIs'
                : subSection === 'usetmx'
                ? 'Usetmx KPIs'
                : subSection === 'tmxSearch'
                ? 'TMX search basic KPIs'
                : 'Top Business Replies list'}
            </h1>
            <h1 className="tmx-analyticsDashboard__topTextSubTitle">
              This information is confidential.{' '}
            </h1>
          </div>
          <div className="tmx-analyticsDashboard__topTextContainerRight">
            <DropDown
              disabled={loading}
              data={optionsData}
              value={overallDataSetType}
              className={'tmx-analyticsDashboard__customDropDown'}
              onChange={(event) => {
                selectCallback(event.target.value);
              }}
            />
          </div>
        </div>
        {subSection === 'newsrooms' ? (
          <AnalyticsNetworkNewsroomOverview
            loading={loading}
            responseData={responseData}
            overallDataSetType={overallDataSetType}
          />
        ) : subSection === 'business' ? (
          <AnalyticsNetworkBusinessOverview
            loading={loading}
            responseData={responseData}
            overallDataSetType={overallDataSetType}
          />
        ) : subSection === 'usetmx' ? (
          <AnalyticsPlatformUsetmxOverview
            loading={loading}
            responseData={responseData}
            overallDataSetType={overallDataSetType}
          />
        ) : subSection === 'tmxSearch' ? (
          <AnalyticsPlatformTmxSearchOverview
            loading={loading}
            responseData={responseData}
            overallDataSetType={overallDataSetType}
          />
        ) : subSection === 'rankingList' ? (
          <>
            {' '}
            <AnimatedList
              items={responseData?.companies}
              onItemSelect={(item, index) => console.log(item, index)}
              showGradients={false}
              enableArrowNavigation={true}
              displayScrollbar={true}
            />
            <div className="tmx-analyticsNetworkNewsroomOverview__topTextContainer">
              <div className="tmx-analyticsNetworkNewsroomOverview__topTextContainerLeft">
                <h1 className="tmx-analyticsNetworkNewsroomOverview__topTextTitle">
                  Top Newsroom Requests list
                </h1>
                <h1 className="tmx-analyticsNetworkNewsroomOverview__topTextSubTitle">
                  This information is confidential.{' '}
                </h1>
              </div>
            </div>
            <AnimatedList
              items={responseData?.newsroom_orgs}
              onItemSelect={(item, index) => console.log(item, index)}
              showGradients={false}
              enableArrowNavigation={true}
              displayScrollbar={true}
              type={'newsroom'}
            />
            <div className="tmx-analyticsNetworkNewsroomOverview__topTextContainer">
              <div className="tmx-analyticsNetworkNewsroomOverview__topTextContainerLeft">
                <h1 className="tmx-analyticsNetworkNewsroomOverview__topTextTitle">
                  Newsrooms added to Slack app
                </h1>
                <h1 className="tmx-analyticsNetworkNewsroomOverview__topTextSubTitle">
                  This information is confidential.{' '}
                </h1>
              </div>
            </div>
            <div className="tmx-analyticsDashboard__iframeContainer">
              <iframe
                src="https://embed.tmxdata.io/public/question/7743d2f1-dceb-4e9a-ab26-5f54726a498d"
                frameborder="0"
                width="100%"
                height="100%"
                title="5f54726a498d"
                allowtransparency></iframe>
            </div>
          </>
        ) : null}
      </section>
    </>
  );
};

AnalyticsDashboard.propTypes = {};

export default AnalyticsDashboard;
